<script setup lang="ts">
import SkeletonBox from '@/components/SkeletonBox.vue';
import SkeletonStyles from '@/assets/sass/utilities/skeletons.module.scss';

</script>

<template>
    <div class="showcase-item">
        <header class="showcase-item__img-container">
            <SkeletonBox height="100%" width="100%" />
        </header>
        <section class="showcase-item__section showcase-item__section--long" :class="SkeletonStyles.shimmer">
            <h3 class="showcase-item__heading showcase-item__heading--no-mb">
                <SkeletonBox height="2rem" />
                <SkeletonBox height="4rem" />
            </h3>
        </section>
        <section class="showcase-item__section" :class="SkeletonStyles.shimmer">
            <SkeletonBox height="3rem" />
            <SkeletonBox height="3rem" />
            <SkeletonBox height="3rem" />
        </section>
        <section class="showcase-item__section" :class="SkeletonStyles.shimmer">
            <SkeletonBox height="5rem" />
        </section>
    </div>
</template>
